import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";
import classNames from "classnames";

interface Props extends WithStyles<typeof styles> {
	className?: string;
	children?: React.ReactNode;
}

class Component extends React.Component<Props> {
	
	public render() {
		const { classes = {}, children, className } = this.props;
		return (
			<Mui.Typography
				className={classNames([
					classes.root,
					className,
				])}
			>
				{children}
			</Mui.Typography>
		);
	}

}

export const ColumnLabel = withStyles(Component, styles);